module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"focus_object_on_hover":"Focus Object on Hover","table":"Table"},"ja":{"focus_object_on_hover":"マウスカーソル下の天体にフォーカス","table":"テーブル"}}')
  delete Component.options._Ctor
}
